/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".status-container[_ngcontent-%COMP%] {\r\n    width:100%;\r\n    max-width:360px;\r\n    margin-left:auto;\r\n    margin-right:auto;\r\n    line-height:17px !important;\r\n    border-radius:5px;\r\n}\r\n\r\n.text-small[_ngcontent-%COMP%] {\r\n    font-size:13px;\r\n}\r\n\r\n.bg-light[_ngcontent-%COMP%]:nth-child(even) {\r\n    background:#FFF !important;\r\n}\r\n\r\n.navbar[_ngcontent-%COMP%] {\r\n  width:100%;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n}"];
export { styles as styles };
